/**
 * Testi italiani degli incarichi guidati all'Institore (ADR 0035): menu, moduli,
 * revisione della sequenza del video, risultati sotto le risposte.
 */

/** Testi degli incarichi. */
export const guided = {
  /** Menu nel campo di scrittura. */
  menu: {
    /** Pulsante, e suo nome accessibile. */
    button: 'Incarichi',
    /** Intestazione del menu e suggerimento del pulsante. */
    heading: 'Chiedi all’Institore di…',
    /** Voci del menu. */
    video_plan: 'Preparare un video demo',
    research: 'Fare una ricerca',
    release_check: 'Controllare se è pronto per la produzione',
    competitors: 'Confronta i competitor',
  },

  /** Campi e messaggi comuni ai moduli. */
  common: {
    /** Campo del progetto. */
    project: 'Progetto',
    /** Progetto da scegliere. */
    projectPlaceholder: 'Scegli un progetto',
    /** Nessun progetto (solo per la ricerca). */
    noProject: 'Nessun progetto',
    /** Progetto mancante. */
    projectMissing: 'Scegli un progetto.',
    /** Progetto tolto dal set nel frattempo. */
    projectGone: 'Il progetto non è più nel set. Scegline un altro.',
    /** Set senza progetti. */
    noProjects: 'Il set non ha progetti. Aggiungine uno dalla scheda Progetti.',
    /** Campo delle note. */
    notes: 'Note',
    /** Invio riuscito. */
    sent: 'Incarico inviato all’Institore.',
    /** Invio non riuscito. */
    failed: 'Invio dell’incarico non riuscito. Riprova.',
  },

  /** Video demo, fase 1. */
  videoBrief: {
    /** Titolo del cassetto. */
    title: 'Video demo',
    /** Come funziona. */
    notice:
      'Prima l’Institore propone la sequenza delle azioni. Poi la rivedi e scegli lingue, durata e voce. Solo allora produce il video.',
    /** Obiettivo. */
    goal: 'Obiettivo del video',
    /** Aiuto dell'obiettivo. */
    goalHelp: 'Per esempio: come si prenota un tavolo, dalla home alla conferma.',
    /** Obiettivo mancante. */
    goalMissing: 'Scrivi che cosa deve mostrare il video.',
    /** Pubblico. */
    audience: 'Pubblico',
    /** Aiuto del pubblico. */
    audienceHelp: 'Facoltativo. Per esempio: titolari di ristoranti.',
    /** Pagina di partenza. */
    startUrl: 'Pagina di partenza',
    /** Aiuto della pagina di partenza. */
    startUrlHelp: 'Facoltativa. L’indirizzo del sito o di una sua pagina.',
    /** Invio. */
    submit: 'Chiedi la proposta',
  },

  /** Sequenza proposta, sotto la risposta. */
  planCard: {
    /** Titolo. */
    title: 'Sequenza proposta',
    /** Numero di azioni. */
    steps_one: '{{count}} azione',
    steps_other: '{{count}} azioni',
    /** Comando. */
    review: 'Rivedi la sequenza',
    /** Blocco illeggibile. */
    unreadable: 'La sequenza proposta non si legge. Chiedi all’Institore di riproporla.',
  },

  /** Video demo, fase 2: revisione della sequenza. */
  plan: {
    /** Titolo del cassetto. */
    title: 'Sequenza del video',
    /** Spiegazione. */
    notice:
      'Modifica, aggiungi o togli le azioni. L’Institore le esegue in quest’ordine, una per ogni lingua scelta.',
    /** Nome accessibile dell'elenco. */
    list: 'Azioni del video',
    /** Titolo di un'azione. */
    step: 'Azione {{index}}',
    /** Azione sullo schermo. */
    action: 'Azione sullo schermo',
    /** Battuta. */
    narration: 'Battuta della voce',
    /** Aiuto della battuta. */
    narrationHelp: 'Vuota per un’azione senza voce.',
    /** Comandi di un'azione (nomi accessibili). */
    moveUp: 'Sposta su l’azione {{index}}',
    moveDown: 'Sposta giù l’azione {{index}}',
    remove: 'Togli l’azione {{index}}',
    /** Aggiunta. */
    add: 'Aggiungi azione',
    /** Tetto raggiunto. */
    addLimit: 'Al più {{max}} azioni.',
    /** Lingue. */
    languages: 'Lingue',
    /** Aiuto delle lingue. */
    languagesHelp: 'Un video per lingua, al più tre.',
    /** Durata. */
    duration: 'Durata di ogni video',
    /** Voce. */
    voice: 'Voce',
    /** Aiuto della voce. */
    voiceHelp: 'La voce consuma i tuoi minuti di voce del mese, gli stessi della conversazione a voce.',
    /** Stima della voce. */
    estimate: 'Voce stimata: {{seconds}} secondi su {{duration}}.',
    /** Minuti consumati in tutte le lingue. */
    minutes_one: 'In tutto consuma circa {{count}} minuto di voce.',
    minutes_other: 'In tutto consuma circa {{count}} minuti di voce.',
    /** Senza voce. */
    noMinutes: 'Senza voce non consuma minuti.',
    /** Minuti rimasti. */
    minutesLeft_one: 'Te ne resta {{count}}.',
    minutesLeft_other: 'Te ne restano {{count}}.',
    /** Minuti senza limite. */
    minutesUnlimited: 'I tuoi minuti non hanno limite.',
    /** Minuti insufficienti. */
    minutesShort: 'Non bastano: scegli meno lingue, accorcia le battute o acquista altri minuti.',
    /** Battute troppo lunghe per la durata. */
    tooLong: 'Le battute durano più del video. Accorciale o scegli una durata più lunga.',
    /** Problemi prima dell'invio. */
    problems: {
      empty: 'Aggiungi almeno un’azione.',
      missingAction: 'Scrivi che cosa succede sullo schermo in ogni azione.',
      tooMany: 'Al più 30 azioni.',
      noLanguage: 'Scegli almeno una lingua.',
      tooManyLanguages: 'Scegli al più tre lingue.',
    },
    /** Invio. */
    submit: 'Produci il video',
  },

  /** Nomi delle lingue. */
  languages: {
    it: 'Italiano',
    en: 'Inglese',
    es: 'Spagnolo',
    fr: 'Francese',
    de: 'Tedesco',
    ru: 'Russo',
    ko: 'Coreano',
    th: 'Tailandese',
  },

  /** Durate. */
  durations: {
    '30': '30 secondi',
    '60': '1 minuto',
    '90': '1 minuto e mezzo',
    '120': '2 minuti',
    '180': '3 minuti',
  },

  /** Voci. */
  voices: {
    giusy: 'Giusy, femminile, italiano',
    alice: 'Alice, femminile, inglese britannico',
    george: 'George, maschile, inglese britannico',
    none: 'Nessuna voce, solo sottotitoli',
  },

  /** Ricerca. */
  research: {
    /** Titolo del cassetto. */
    title: 'Ricerca',
    /** Che cosa si riceve. */
    notice:
      'Ricevi il report in tre versioni: principale, con le fonti per esteso, con le sole fonti come link. In più una pagina HTML.',
    /** Argomento. */
    topic: 'Argomento',
    /** Aiuto dell'argomento. */
    topicHelp: 'Una domanda precisa dà risultati migliori.',
    /** Argomento mancante. */
    topicMissing: 'Scrivi l’argomento della ricerca.',
    /** Decisione. */
    decision: 'Decisione da prendere',
    /** Aiuto della decisione. */
    decisionHelp: 'Facoltativa. Per esempio: scegliere fra due fornitori.',
    /** Effort. */
    effort: 'Effort',
    /** Livelli di effort. */
    efforts: {
      low: 'Low: 10-20 minuti, 5-8 fonti',
      medium: 'Medium: 30-60 minuti, 12-20 fonti, anche comunità e codice',
      high: 'High: 1-3 ore, 25 fonti o più, più filoni in parallelo',
    },
    /** Lingua del report. */
    reportLanguage: 'Lingua del report',
    /** Vincoli. */
    constraints: 'Vincoli e fonti',
    /** Aiuto dei vincoli. */
    constraintsHelp: 'Facoltativi. Fonti da preferire o da escludere, periodo, paesi.',
    /** Invio. */
    submit: 'Avvia la ricerca',
  },

  /** Controllo prima della produzione. */
  release: {
    /** Titolo del cassetto. */
    title: 'Controllo prima della produzione',
    /** Che cosa succede. */
    notice:
      'L’Institore analizza il progetto senza modificarlo. Ricevi un rapporto con priorità e passi, e i bloccanti come task proposti.',
    /** Destinazione. */
    target: 'Destinazione',
    /** Destinazioni. */
    targets: {
      institor: 'Hosting di institor',
      cloud: 'Un altro cloud',
      mobile_store: 'Store delle app',
      unknown: 'Da decidere',
    },
    /** Utenti attesi. */
    users: 'Utenti attesi',
    /** Fasce di utenti. */
    usersOptions: {
      under_100: 'Meno di 100',
      under_10k: 'Fino a 10.000',
      over_10k: 'Oltre 10.000',
      unknown: 'Non so',
    },
    /** Dati personali. */
    personalData: 'Dati personali',
    /** Pagamenti. */
    payments: 'Pagamenti',
    /** Risposte. */
    answers: {
      yes: 'Sì',
      no: 'No',
      unknown: 'Non so',
    },
    /** Lancio previsto. */
    launchDate: 'Lancio previsto',
    /** Aiuto del lancio. */
    launchDateHelp: 'Facoltativo. Per esempio: fine novembre.',
    /** Invio. */
    submit: 'Avvia il controllo',
  },

  /** Confronto con i competitor (ADR 0060). */
  competitors: {
    /** Titolo del cassetto. */
    title: 'Confronta i competitor',
    /** Che cosa succede. */
    notice:
      'Uno specialista cerca i competitor e legge le loro pagine pubbliche. Ricevi in chat un rapporto con le fonti e le proposte per superarli. Diventano requisiti solo se le approvi.',
    /** Settore. */
    sector: 'Settore e prodotto',
    /** Aiuto del settore. */
    sectorHelp: 'Una frase. Per esempio: app di prenotazione per piccoli ristoranti.',
    /** Settore mancante. */
    sectorMissing: 'Scrivi il settore e il prodotto.',
    /** Mercato. */
    market: 'Mercato',
    /** Mercato proposto all'apertura. */
    marketDefault: 'Italia',
    /** Aiuto del mercato. */
    marketHelp: 'Paese o area. Per esempio: Italia, Europa, tutto il mondo.',
    /** Mercato mancante. */
    marketMissing: 'Scrivi il mercato.',
    /** Competitor già noti. */
    named: 'Competitor che conosci',
    /** Aiuto dei competitor. */
    namedHelp: 'Facoltativi. Nome o indirizzo, uno per riga, al più {{max}}. Gli altri li trova lo specialista.',
    /** Problemi dei competitor. */
    problems: {
      tooMany: 'Indica al più {{max}} competitor.',
      tooLong: 'Un competitor ha un nome troppo lungo. Accorcialo.',
    },
    /** Piattaforme. */
    platforms: 'Piattaforme',
    /** Aiuto delle piattaforme. */
    platformsHelp: 'Facoltative. Senza scelta si confrontano tutte quelle del progetto.',
    /** Nomi delle piattaforme. */
    platformNames: {
      web: 'Web',
      android: 'Android',
      ios: 'iOS',
    },
    /** Domanda. */
    question: 'Domanda o obiettivo',
    /** Aiuto della domanda. */
    questionHelp: 'Facoltativa. Per esempio: voglio capire i prezzi.',
    /** Effort. */
    effort: 'Effort',
    /** Livelli di effort. */
    efforts: {
      low: 'Low: 5 competitor, circa 10 minuti',
      medium: 'Medium: 7 competitor, circa 15 minuti, anche le opinioni',
      high: 'High: 10 competitor, circa 30 minuti, modello più costoso',
    },
    /** Lingua del rapporto. */
    reportLanguage: 'Lingua del rapporto',
    /** Invio. */
    submit: 'Avvia il confronto',
  },

  /** Risultati sotto la risposta. */
  outputs: {
    /** Nome accessibile dell'elenco. */
    label: 'Risultati',
    /** Comando. */
    download: 'Scarica',
    /** Nome accessibile del comando. */
    downloadName: 'Scarica {{name}}',
    /** Nome accessibile dell'anteprima. */
    preview: 'Anteprima di {{name}}',
  },
};

/** Forma dei testi degli incarichi, per la traduzione inglese. */
export type Guided = typeof guided;
